import React, { useEffect, useRef } from 'react';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

const LegalHero = ({ eyebrow, title, description }) => {
  const heroRef = useRef(null);

  useEffect(() => {
    const container = heroRef.current;
    if (!container) return;

    const items = container.querySelectorAll('.magnetic-item');

    const handleMove = (event) => {
      const target = event.currentTarget;
      const rect = target.getBoundingClientRect();
      const offsetX = (event.clientX - rect.left - rect.width / 2) * 0.05;
      const offsetY = (event.clientY - rect.top - rect.height / 2) * 0.05;
      target.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    };

    const handleLeave = (event) => {
      event.currentTarget.style.transform = 'translate(0, 0)';
    };

    items.forEach((item) => {
      item.addEventListener('mousemove', handleMove);
      item.addEventListener('mouseleave', handleLeave);
    });

    return () => {
      items.forEach((item) => {
        item.removeEventListener('mousemove', handleMove);
        item.removeEventListener('mouseleave', handleLeave);
      });
    };
  }, []);

  return (
    <section className="breadcrumbs legal-hero" ref={heroRef}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-wrapper">
              <Reveal className="breadcrumb-cnt" delay={0.06}>
                {eyebrow && (
                  <span>
                    <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                      {eyebrow}
                    </GradientText>
                  </span>
                )}
                <h1>
                  <ShinyText
                    text={title}
                    className="nalexus-heading-shine"
                    color="#f1ede3"
                    shineColor="#ffd369"
                    speed={2.6}
                  />
                </h1>
                {description && <p className="legal-hero__lead">{description}</p>}
                <div className="breadcrumb-list">
                  <a href="/">Home</a>
                  <img src="/assets/img/content/breadcrumb-arrow.svg" alt="Breadcrumb divider" />
                  {title}
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalHero;





